import { CountryIconProps } from './types';

const BJ = ({ dimension }: CountryIconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1046_3573)">
      <path
        d="M7.82617 10.9569L8.86966 23.587C9.86777 23.856 10.9169 24.0004 12.0001 24.0004C18.6274 24.0004 24.0001 18.6278 24.0001 12.0004L7.82617 10.9569Z"
        fill="#D80027"
      />
      <path
        d="M7.82617 12.0001L8.86961 0.413513C9.86777 0.144497 10.9169 0.00012207 12.0001 0.00012207C18.6274 0.00012207 24.0001 5.37275 24.0001 12.0001H7.82617Z"
        fill="#FFDA44"
      />
      <path
        d="M0 11.9997C0 17.544 3.76036 22.2093 8.86955 23.5863V0.413086C3.76036 1.79009 0 6.45537 0 11.9997Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_1046_3573">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default BJ;
